import FormBaseModel from '@cp-models/FormBaseModel';

export default class Address extends FormBaseModel {
    casts()
    {
        return {
            'id': 'number',
            'zip_code': 'string',
            'street': 'string',
            'number': 'number',
            'district': 'string',
            'complement': 'string',
            'city': 'string',
            'state': 'string',
        }
    }

}
